<i v-if="loading" class="fas fa-spinner fa-spin"></i>